export function Modalstart({ show, setShow }) {
  if (show) {
    return (
      <>
        <div
          id="overlay"
          //  onClick={()=>setShow(false)}
          className="top-0 left-0 w-full h-full "
          style={{
            position: "fixed",
            backgroundColor: "rgba(0,0,0,0.5)",
            display: " flex",
            alignItems: " center",
            // justifyContent:" center",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              // zIndex:"10002",
              // width:"50%",
              padding: "",
              // background:"#fff",
            }}
            className="max-h-[70vh] overflow-y-auto z-90 w-3/4 mx-auto"
          >
            <div>
              <div>
                <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-4 py-8 bg-gradient-to-r from-black/80 via-black/80 to-black/70 rounded-3xl">
                  <div className="text-center pb-6">
                    <h1 className="font-bold text-xl md:text-2xl lg:text-3xl font-heading text-gray-100">
                      ジオグラフヘようこそ！
                    </h1>

                    <div className="text-base md:text-xl lg:text-xl my-8 text-gray-100">
                      <>
                        <p>棒グラフをタップしてみましょう！</p>
                        <br />
                        <p>地面をタップしてみましょう！</p>
                        <br />
                        <p>いろいろなボタンを押してみましょう！</p>
                      </>
                    </div>
                  </div>
                  <button
                    onClick={() => {
                      setShow(true);
                      // setArea1Set("福岡県糸島市");setArea2Set("福岡県糸島市");
                    }}
                    className="relative inline-flex items-center justify-center p-0.5 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-cyan-500 to-blue-500 group-hover:from-cyan-500 group-hover:to-blue-500 hover:text-white dark:text-white focus:ring-4 focus:ring-cyan-200 dark:focus:ring-cyan-800"
                  >
                    <span className="relative px-5 py-2.5 transition-all ease-in duration-75 bg-white dark:bg-gray-900 rounded-md group-hover:bg-opacity-0">
                      ジオグラフを始める！
                    </span>
                  </button>
                </section>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  } else {
    return null;
  }
}
